import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const getMethodByYear = async (idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/methode/year/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateMethod = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/methode/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getDocumentationSettingYear = async (idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/documentation/year/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateDocumentationSetting = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/documentation/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllLevelTypes = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/typeLevel/getAll`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const getLevelTypeByID = async (levelTypeID, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/typeLevel/getById/${levelTypeID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createLevelType = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/typeLevel/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteLevelType = async (levelTypeID, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/typeLevel/delete/${levelTypeID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateLevelType = async (payload, levelTypeID, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/typeLevel/update/${levelTypeID}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllCycle = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/cycle/getAll`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const getCycleOptionsForEmargement = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/cycle/getAllForEmargement`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getCycleByID = async (cycleID, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/cycle/getById/${cycleID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createCycle = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/cycle/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteCycle = async (cycleID, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/cycle/delete/${cycleID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateCycle = async (payload, cycleID, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/cycle/update/${cycleID}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllParcours = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parcours/allParcours`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentParcours = async (idStudent, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parcours/studentParcours/${idStudent}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getParcoursByID = async (parcoursID, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/parcours/getById/${parcoursID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createParcours = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/parcours/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteParcours = async (parcoursID, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/parcours/delete/${parcoursID}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteStudentParcours = async (id_parcourStudent, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/parcours/student/delete/${id_parcourStudent} `,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateParcours = async (payload, parcoursID, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/parcours/update/${parcoursID}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
